__webpack_require__.p = "https://quickview.kindle.amazon.dev/";